// extracted by mini-css-extract-plugin
export default {"registrationForm":"style_registrationForm__YNTKu","inputLabel":"style_inputLabel__v4ukS","label":"style_label__BulDf"};